import { Component, OnInit,Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CaptchaService } from 'src/app/components/layout/service/captcha.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { ModErrorComponent } from '../../layout/modals/mod-error/mod-error.component';

@Component({
  selector: 'app-medical-test',
  templateUrl: './medical-test.component.html',
  styleUrls: ['./medical-test.component.css']
})
export class MedicalTestComponent implements OnInit {
  @Input() publicJwt: string;
  key:string;
  publicJWT: string;
  request: any;
  people: any;

  constructor(private dataApi: CaptchaService,
    private _snackBar: MatSnackBar,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router) { 
      this.publicJwt = this.route.snapshot.queryParamMap.get('token');
      this.key = environment.googleCaptchaProps.key;
    }

  resolved(captchaResponse: string) {
    if(this.publicJwt===null || this.publicJwt===undefined){
      this.router.navigate(['/404']);
    }
    this.spinner.show("loading");
    this.dataApi.verifyCaptcha(captchaResponse, this.publicJwt).subscribe((data: any)=> {
    this.spinner.hide("loading");
    }, () =>{
      this.spinner.hide("loading");
      this.dialog.open(ModErrorComponent, {
        width: 'auto',
        panelClass: 'myapp-no-padding-dialog',

      });

    });
  }

   getMedicalTest(){
     this.spinner.show("loading");
     this.dataApi.getMedicalTest(this.publicJwt).subscribe((data: any)=> {
      this.request= data.request;
      this.people= data.personalData;
     this.spinner.hide("loading");
     }, () =>{
       this.spinner.hide("loading");
       this.dialog.open(ModErrorComponent, {
        width: 'auto',
        panelClass: 'myapp-no-padding-dialog',

      });
     });
   }


  ngOnInit() {
    this.getMedicalTest();
  }

  onSubmit(value)
  {
    const AccessRequest = {
      medicalTest : value
    }

    this.dataApi.putMedicalTest(AccessRequest, this.publicJwt).subscribe( (response)=>{
      
      this.spinner.hide("loading");
      //moduificar pántalla confirmation
      if(response.qualificationStatus===2 || response.qualificationStatus===3 ){
        // this.router.navigate(['/medical-confirmation/success?result='+response.medicalTest]);
        this.router.navigate(['/medical-confirmation/success/'+response.qualificationStatus]);
      } else{
        this.router.navigate(['/medical-confirmation/fail/'+response.qualificationStatus]);
      }
    }, ()=>{
      this.spinner.hide("loading");
      this.dialog.open(ModErrorComponent, {
        width: 'auto',
        panelClass: 'myapp-no-padding-dialog',

      });
    })

  }


}
